<template>
    <div class="mainHeader">
        <!--
        <v-menu
            bottom
            :offset-y="true"
            transition="slide-y-transition"
        >
            <template v-slot:activator="{on,attrs}">
                <div class="menu-button"
                     v-bind="attrs"
                     v-on="on"
                ></div>
            </template>
            <v-list>
                <v-list-item v-if="allowed.dependencies" class="menu-item" dense @click="menuClicked('syntax')">
                    <v-list-item-icon class="menu-item-icon menu-item-icon-dependencies"></v-list-item-icon>
                    <v-list-item-title>{{$t('Dependencies')}}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="allowed.replacements" class="menu-item" dense @click="menuClicked('replacements')">
                    <v-list-item-icon class="menu-item-icon menu-item-icon-replacements"></v-list-item-icon>
                    <v-list-item-title>{{$t('Replacements')}}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="allowed.amendments" class="menu-item" dense @click="menuClicked('amendments')">
                    <v-list-item-icon class="menu-item-icon menu-item-icon-amendments"></v-list-item-icon>
                    <v-list-item-title>{{$t('Amendments')}}</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="allowed.languageSelector" class="menu-item" dense>
                    <v-list-item-icon class="menu-item-icon menu-item-icon-language"></v-list-item-icon>
                    <v-menu
                            right
                            :offset-x="true"
                            transition="slide-x-transition"
                    >
                        <template v-slot:activator="{on,attrs}">
                            <v-list-item-title
                                v-bind="attrs"
                                v-on="on"
                                open-on-hover="true"
                            >{{$t('Language')}}: {{language}}</v-list-item-title>
                        </template>
                        <v-list>
                            <v-list-item
                                    class="menu-item"
                                    dense
                                    v-for="language in this.languages"
                                    :key="language.id"
                            >
                                <v-list-item-title @click="changeLanguage(language.id)">{{language.name}}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-list-item>
                <v-list-item v-if="allowed.themeSelector" class="menu-item" dense>
                    <v-list-item-icon class="menu-item-icon menu-item-icon-color"></v-list-item-icon>
                    <v-menu
                            right
                            :offset-x="true"
                            transition="slide-x-transition"
                    >
                        <template v-slot:activator="{on,attrs}">
                            <v-list-item-title
                                    v-bind="attrs"
                                    v-on="on"
                                    open-on-hover="true"
                            >{{$t('Color')}}: {{theme}}</v-list-item-title>
                        </template>
                        <v-list>
                            <v-list-item
                                    class="menu-item"
                                    dense
                                    v-for="theme in this.themes"
                                    :key="theme"
                            >
                                <v-list-item-title @click="changeTheme(theme)">{{theme}}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-list-item>
                <v-list-item v-if="allowed.flow" class="menu-item" dense @click="menuClicked('flow')">
                    <v-list-item-icon class="menu-item-icon menu-item-icon-external"></v-list-item-icon>
                    <v-list-item-title>SC Flow</v-list-item-title>
                </v-list-item>
                <v-list-item v-if="allowed.tariffDb" class="menu-item" dense @click="menuClicked('tariffDatabase')">
                    <v-list-item-icon class="menu-item-icon menu-item-icon-external"></v-list-item-icon>
                    <v-list-item-title>Tariff Database</v-list-item-title>
                </v-list-item>
                <v-list-item class="menu-item" dense @click="logOut">
                    <v-list-item-icon class="menu-item-icon menu-item-icon-logout"></v-list-item-icon>
                    <v-list-item-title>{{$t('Logout')}}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        -->
        <div class="currentView">
            <div
                class="menu-entry"
                v-for="entry in breadcrumb"
                :key="entry.display"
            >
                <div
                        class="menu-label"
                        :class="(entry.last ? '' : 'inactive') + ' ' + (typeof entry.route !== 'undefined' ? 'clickable' : '')"
                        @click="headerNavigationClicked(entry)"
                >{{entry.display}}</div>
                <div v-if="!entry.last" class="menu-separator"/>
            </div>
        </div>
        <div class="headerButtons">
            <div v-if="allowed.changePassword" class="headerButton profile"
                 >{{$auth.user().name}}</div>
            <div v-if="allowed.termsOfUse" class="headerButton termsOfUse slim"
                 v-on:click="openTermsOfUse"/>
            <div v-if="allowed.changePassword" class="headerButton changePassword slim"
                 v-on:click="changePassword"/>
            <div v-if="allowed.changePassword" class="headerButton logout"
                 @click="logOut">{{logoutTime + ''}}</div>
        </div>
        <div
            v-if="showTabBar"
            class="tabBar">
            <div
                v-for="(tab, index) in tabBarTabs"
                :key="tab.id"
            >
                <div class="tab" @click="changeActiveTab(tab.id)">
                    <div class="tab-content"
                         :class="{active: activeTab === tab.id}"
                         :key="tab.id + '_' + activeTab"
                         v-html="tab.name"
                    />
                </div>
                <div
                    v-if="tabBarClose || index + 1 < tabBarTabs.length"
                    class="tab-separator"></div>
            </div>
            <div v-if="tabBarClose" class="tab tab-close" @click="menuClicked('syntax')"><img src="../assets/icons/header/close.svg" title="close" alt="close"></div>
        </div>
    </div>
</template>

<script>
    import router from "../router";
    import i18n from '../i18n';
    import authorization from "../plugins/authorization";

    export default {
        name: "Header",
        props: {
            language:  String,
            languages: Array,
            theme:     String,
            themes:    Array
        },
        data: function() {
            return {
                logoutTime:  60,
                currentView: 'CEDEX SYNTAX',
                path:        [],
                showTabBar:  false,
                tabBarTabs:  [],
                activeTab:   '',
                tabBarClose: false,

                allowed: {
                    dependencies:     authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/View'),
                    replacements:     authorization.isAllowed('Settings/CEDEX Settings/Replacements/MERC'),
                    amendments:       authorization.isAllowed('Settings/CEDEX Settings/Amendments'),
                    flow:             authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/Main Menu/Flow'),
                    tariffDb:         authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/Main Menu/Tariff DB'),
                    termsOfUse:       authorization.isAllowed('Settings/CEDEX Settings/Dependencies/Editor/Main Menu/Terms of Use'),
                    changePassword:   false,

                    languageSelector: false,
                    themeSelector:    false,
                },
            };
        },
        methods: {
            async logOut() {
                if (await this.$confirmLeaveDialog()) {
                    this.$auth.logout();
                }
            },
            routeProfile() {
                router.push({name: 'Profile'});
            },
            openTermsOfUse() {
                router.push({name: 'TermsOfUse'});
            },
            changePassword() {
                router.push({name: 'ChangePassword'});
            },
            calculateLogoutTime() {
                let currentTime = Math.floor(Date.now() / 1000);
                let user = this.$auth.user();
                if (user === null) {
                    this.logoutTime = 0;
                } else {
                    let secondsLoggedIn = user.validUntil - currentTime;
                    if (secondsLoggedIn <= 0) {
                        this.logoutTime = 0;
                    } else {
                        this.logoutTime = Math.round(secondsLoggedIn / 60);
                    }
                }
            },
            // events
            async menuClicked(item) {
                if (item === 'flow') {
                    window.open(process.env.VUE_APP_API_URL, '_blank');
                } else if (item === 'tariffDatabase') {
                    window.open('https://hccr.tdb.survey-compass.com', '_blank');
                } else {
                    let res = await this.$confirmLeaveDialog();
                    if (res) {
                        router.push(item);
                    }
                }
            },
            async headerNavigationClicked(entry) {
                let res = await this.$confirmLeaveDialog();
                if (
                    !res
                    || typeof entry.route === 'undefined'
                ) {
                    return;
                }
                let routeName = entry.route || 'Root';
                if (routeName === 'Root') {
                    this.path = [];
                }
                router.push({name: routeName})
            },
            changeLanguage(selectedLanguage) {
                i18n.locale = selectedLanguage;
                for(let language in this.languages) {
                    if (language.id === selectedLanguage) {
                        this.language = language.name;
                        break;
                    }
                }
            },
            changeTheme(selectedTheme) {
                console.log(selectedTheme);
                this.theme = selectedTheme
            },
            updateHeaderNavigation(path) {
                this.path = path;
                this.showTabBar = false;
            },
            updateHeaderTabBar(data) {
                if (
                    typeof data !== 'object'
                    || data === null
                ) {
                    this.showTabBar = false;
                } else {
                    this.showTabBar  = true;
                    this.tabBarTabs  = data.tabs;
                    this.tabBarClose = data.showClose;
                    this.activeTab   = data.active;
                }
            },
            changeActiveTab: function(tabId) {
                this.activeTab = tabId;
                this.$emit('changeTabBarTab', [tabId]);
            }
        },
        computed: {
            breadcrumb() {
                let breadcrumb = [];
                breadcrumb.push({
                    display: this.currentView,
                    route:   '',
                    last:    this.path.length === 0
                });

                for (let index in this.path) {
                    let entry = {};
                    if (typeof this.path[index] === 'string') {
                        entry.display = this.path[index];
                    } else if (typeof this.path[index] === 'object') {
                        entry.display = this.path[index].display || 'Unnamed Menu';
                        if (typeof this.path[index].route === 'string') {
                            entry.route = this.path[index].route;
                        }
                    }

                    if ((parseInt(index) || 0) === this.path.length - 1) {
                        entry.last = true;
                    }

                    breadcrumb.push(entry);
                }

                return breadcrumb;
            }
        },
        mounted: function() {
            this.$auth
                .load()
                .then(() => {
                    if (this.$auth.check()) {
                        let userData = JSON.parse(this.$auth.remember());
                        this.$auth.user(userData);

                        this.allowed.changePassword = !userData.loggedInByAuthToken;
                    }
                });
            setInterval((function() {
                this.calculateLogoutTime();
            }).bind(this), 5000);
        }
    }
</script>

<style scoped>
    div.mainHeader {
        background-color: var(--main-header);
        color: white;
        font-size: 11pt;
        text-align: left;
        height: 32px;
        min-height: 32px;
    }

    div.mainHeader div {
        display: inline-block;
        vertical-align: top;
        height: 100%;
        line-height: 235%;
    }

    div.mainHeader div.currentView div.menu-entry div.menu-label {
        padding: 0 16px;
    }

    div.mainHeader div.currentView div.menu-entry div.menu-label.inactive {
        color: #afbcc8;
    }

    div.mainHeader div.currentView div.menu-entry div.menu-label.clickable {
        cursor: pointer;
    }

    div.mainHeader div.currentView div.menu-entry div.menu-separator {
        width: 16px;
        margin: 0 16px;
        background-image: url("../assets/icons/header/arrow-right.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 14px;
    }

    div.menu-button {
        background-image: url("../assets/icons/header/menu.svg");
        background-size: 18px;
        background-repeat: no-repeat;
        width: 64px;
        background-position: center;
    }
    div.menu-button:hover{
        background-color: rgba(255, 255, 255, 0.1);
    }

    div.menu-item-icon-dependencies {
        background-image: url("../assets/icons/toolbar/dependencies.svg");
    }
    div.menu-item-icon-replacements {
        background-image: url("../assets/icons/toolbar/replacements.svg");
    }
    div.menu-item-icon-amendments {
        background-image: url("../assets/icons/toolbar/amendments.svg");
    }
    div.menu-item-icon-language {
        background-image: url("../assets/icons/header/language.svg");
    }
    div.menu-item-icon-color {
        background-image: url("../assets/icons/header/color.svg");
    }
    div.menu-item-icon-external {
        background-image: url("../assets/icons/header/external-link.svg");
    }
    div.menu-item-icon-logout {
        background-image: url("../assets/icons/header/logout-menu.svg");
    }

    div.currentView {

    }

    div.tabBar {
        padding: 0;
        border-left: 1px solid white;
        border-right: 1px solid white;
        margin-left: 16px;
    }
    div.tab {
        padding: 0 16px;
        color: #afbcc8;
    }
    div.tab:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
    div.tab-separator {
        border-left: 1px solid rgba(255,255,255,0.2);
        margin: 4px 0;
        width: 1px;
        height: 24px !important;
    }
    div.tab-content {
        padding: 0 16px;
    }

    div.tab-content.active {
        border-bottom: 2px solid white;
        color: white;
    }
    div.tab-close {
        padding: 4px 16px;
    }

    div.headerButtons {
        float: right
    }
    div.headerButtons div.headerButton {
        background-repeat: no-repeat;
        background-size: 18px;
        background-position: 8px center;
        padding: 0 8px 0 30px;
        margin: 0;
        vertical-align: top;
        cursor: pointer;
    }

    div.headerButtons div.headerButton.slim {
        padding: 0 16px;
    }

    div.headerButtons div.headerButton.profile {
        background-image: url(../assets/icons/header/profile.svg);
    }

    div.headerButtons div.headerButton.termsOfUse {
        background-image: url(../assets/icons/header/terms-of-use.svg);
    }


    div.headerButtons div.headerButton.changePassword {
        background-image: url(../assets/icons/header/password.svg);
    }

    div.headerButtons div.headerButton.logout {
        font-weight: bolder;
        background-image: url(../assets/icons/header/logout.svg);
    }

    div.headerButtons div.headerButton.logout:after {
        font-weight: normal;
        content: ' min';
    }
</style>
<style>
    .menu-item {
        padding: 0 8px;
    }

    .menu-item:hover {
        background-color: var(--main-menu-background);
    }

    .menu-item-icon {
        width: 24px;
        height: 24px;
        margin-right: 16px !important;
    }

    span.bold {font-weight: bold;}
</style>